export function EditSerialGenre(props) {
    const genre = props.serialGenre?.genre;

    if (!genre) {
        alert("Жанр не знайдено!")
        return null;
    }

    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: '#e0e7ff',
            color: '#4338ca',
            padding: '0px 10px',
            borderRadius: '16px',
            margin: '4px',
            fontSize: '14px',
            fontWeight: '500',
            border: '1px solid #c7d2fe'
        }}>
            <span style={{ marginRight: '6px' }}>{genre.name}</span>
            <button
                onClick={() => props.onDeleteClicked(props.serialGenre)}
                title="Видалити жанр"
                style={{
                    border: 'none',
                    background: 'none',
                    color: '#ef4444',
                    cursor: 'pointer',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    padding: '0 2px',
                    lineHeight: '1'
                }}
            >
                ×
            </button>
        </div>
    );
}